"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBeaconTrackedEvents_1 = __importDefault(require("../events/getBeaconTrackedEvents"));
const flushEventQueues_1 = __importDefault(require("./flushEventQueues"));
const flushWebVitals_1 = __importDefault(require("./flushWebVitals"));
const sendBeacon_1 = __importDefault(require("./sendBeacon"));
/**
 * Flush and beacon all events in the event queues and call the beacon callback
 * if defined.
 *
 * @todo Enforce required config properties and staticDimensions are present
 *   before beaconing.
 * @todo Omit any staticDimensions set to `null` or `undefined` before sending
 *   beacons. (Especially `ZUID`. See
 *   [PERF-594](https://zbrt.atl.zillow.net/browse/PERF-594))
 */
function triggerBeacon(profiler, { isFinalBeacon } = { isFinalBeacon: false }) {
    const { appConfig, debug, eventRegistry } = profiler;
    const { beaconCallback, beaconUrl, productionDomain, staticDimensions } = appConfig;
    // Prepare the beacon options
    const opts = {
        beaconUrl,
        debug,
        eventsEnd: [],
        eventsStart: [],
        productionDomain,
        staticDimensions,
        trackedEventDetails: [],
    };
    // Flush all buffered events
    (0, flushEventQueues_1.default)(profiler, opts);
    // On the final beacon, add any defined metrics and attribution details for
    // Web Vitals supported by the browser
    if (isFinalBeacon)
        (0, flushWebVitals_1.default)(profiler, opts);
    // Bail if there are no events for us to beacon
    const { eventsStart, eventsEnd } = opts;
    const hasEvents = eventsStart.length > 0 || eventsEnd.length > 0;
    if (!hasEvents)
        return false;
    // Add details for the events we'll be sending in this payload
    opts.trackedEventDetails = (0, getBeaconTrackedEvents_1.default)(eventRegistry, eventsStart, eventsEnd);
    // Beacon if there are things to beacon and call the beacon callback
    // with the same options if defined
    if (beaconCallback)
        beaconCallback(opts);
    return (0, sendBeacon_1.default)(opts);
}
exports.default = triggerBeacon;
